import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../Styles/sign-in.css";
import { AppContext } from "../../context/AppContextProvider";
import useAxiosInstance from "../../lib/useAxiosInstance";
import Logo from "../../assets/images/logo/PS-Logo 3.png";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
import LoginPageVideo from "../../assets/videos/login-page-video1.mp4";
import LazyLoad from "react-lazyload";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const Login = () => {
  const { t } = useTranslation();

  const axiosInstance = useAxiosInstance();

  const [showEmailLogin, setShowEmailLogin] = useState(true);
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const { setIsLoggedIn, setThemes } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // New state for OTP functionality
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [otpError, setOtpError] = useState("");
  const [otpResendLoading, setOtpResendLoading] = useState(false);



  const handleLoginFormChangeType = () => {
    setEmail("");
    setPhone("");
    setPassword("");
    setShowEmailLogin(!showEmailLogin);
  }

  // validate form
  const validateEmailForm = () => {
    const emailValid = email.trim() !== "";
    const passwordValid = password.trim() !== "";

    setEmailError(emailValid ? "" : "Email is required!");
    setPasswordError(passwordValid ? "" : "Password is required!");

    const isValid = emailValid && passwordValid;
    setIsValid(isValid);
    return isValid;
  };

  const validatePhoneForm = () => {
    const phoneValid = phone.trim().length == 10;

    setPhoneError(phoneValid ? "" : "Phone Number should be 10 digits!");

    const isValid = phoneValid;
    setIsValid(isValid);
    return isValid;
  };

  // Call validateForm whenever the email or password field is updated.

  const handleEmailChange = (event) => {
    const value = event.target.value;
    setEmail(value);
    setEmailError(value.trim() !== "" ? "" : "Email is required!");
    setIsValid(!isValid);
  };

  const handlePasswordChange = (event) => {
    const value = event.target.value;
    setPassword(value);
    setPasswordError(value.trim() !== "" ? "" : "Password is required!");
    setIsValid(false);
  };

  const handlePhoneChange = (event) => {
    const value = event.target.value;
    // console.log(value)
    setPhone(value);
    setPhoneError(value.trim().length == 10 ? "" : "Phone Number should be 10 digits!");
    setIsValid(false);
  };


  // OTP input handlers
  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus to next input
    if (value && index < 3) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    // Handle backspace to move to previous input
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  // for navigation to page
  let navigate = useNavigate();



  //axios call for login api

  const handleLogin = (e) => {
    e.preventDefault();
    let isValid = false;
    if (showEmailLogin) {
      isValid = validateEmailForm();
    } else {
      isValid = validatePhoneForm();
    }
    if (isValid) {
      setIsLoading(true);


      let reqBody;
      if (showEmailLogin) {
        reqBody = {
          email: email,
          password: password
        };
      } else {
        reqBody = {
          phone: phone,
          password: password
        }
      }


      axiosInstance
        .post("api/clients/login", reqBody)
        .then((response) => {

          if (response.data.data) {
            
            setIsLoggedIn(true);
            // console.log("Client user data: ", response.data.data);
            // console.log("Client user token: ", response.data.data.token);
            localStorage.clear();

            localStorage.setItem("client-token", response.data.data.token);
            localStorage.setItem(
              "user",
              JSON.stringify(response.data.data.clientUser)
            );

            setThemes((storedThemes) => storedThemes || "lightMode");

            // ["data_entry_operator", "office_manager","cadre"].includes(
            //   response?.data?.data?.clientUser?.role
            // )
            //   ? navigate("/gms")
            //   : navigate("/dashboard");
            ["data_entry_operator", "office_manager"].includes(response?.data?.data?.clientUser?.role) ? 
                // If data_entry_operator or office_manager → go to GMS
                navigate("/gms")
                : response?.data?.data?.clientUser?.role === "cadre" ? 
                // If cadre → go to Medical Camp
                navigate("/medical-camp")
                : 
                // Otherwise default → Dashboard
                navigate("/dashboard")
          } else {
            if (response.data.message === "OTP sent on registered mobile number") {
              // console.log("toast - otp sent should show");
              toast.success("OTP sent on registered mobile number");
              setShowOtpScreen(true);
            }
          }

          // console.log("response", response.data);
        })
        .catch((error) => {
          if (error?.response?.data?.message === "This account is suspended.") {
            setLoginError(t("accountSuspended"));
          } else if (error?.response?.data?.message === "clientUser does not exist") {
            setLoginError(t("userNotExist"));
          } else if (error?.response?.data?.message === "You are not authorized to access this application.") {
            setLoginError(t("userNotAuthorized"));
          } else {
            setLoginError(t("invalidEmailPassword"));
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };


  // Handle OTP verification
  const handleVerifyOtp = (e) => {
    e.preventDefault();

    const otpValue = otp.join("");
    if (otpValue.length !== 4) {
      setOtpError("Please enter a valid 4-digit OTP");
      return;
    }

    setIsLoading(true);

    let reqBody;
    if (showEmailLogin) {
      reqBody = {
        email: email,
        otp: otpValue
      };
    } else {
      reqBody = {
        phone: phone,
        otp: otpValue
      }
    }

    axiosInstance
      .post("api/clients/verify-otp-login", reqBody)
      .then((response) => {

        setIsLoggedIn(true);
        handleBackToLogin();


        // console.log("Client user data: ", response.data.data);
        // console.log("Client user token: ", response.data.data.token);
        localStorage.clear();

        localStorage.setItem("client-token", response.data.data.token);
        localStorage.setItem(
          "user",
          JSON.stringify(response.data.data.clientUser)
        );

        setThemes((storedThemes) => storedThemes || "lightMode");

        // ["data_entry_operator", "office_manager","cadre"].includes(
        //   response?.data?.data?.clientUser?.role
        // )
        //   ? navigate("/gms")
        //   : navigate("/dashboard");
        ["data_entry_operator", "office_manager"].includes(response?.data?.data?.clientUser?.role) ? 
                // If data_entry_operator or office_manager → go to GMS
                navigate("/gms")
                : response?.data?.data?.clientUser?.role === "cadre" ? 
                // If cadre → go to Medical Camp
                navigate("/medical-camp")
                : 
                // Otherwise default → Dashboard
                navigate("/dashboard")

      })
      .catch((error) => {
        if (error?.response?.data?.message === "Incorrect OTP. Please try again.") {
          setOtpError(t("Incorrect OTP. Please try again."));
        } else if (error?.response?.data?.message === "Timeout. Please try again.") {
          setOtpError(t("Timeout. Please try again"));
        } else if (error?.response?.data?.message === "You are not authorized to access this application.") {
          setOtpError(t("userNotAuthorized"));
        } else {
          setOtpError(t(error?.response?.data?.message || "Something went wrong"));
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Handle resend OTP
  const handleResendOtp = () => {

    let isValid = false;
    if (showEmailLogin) {
      isValid = validateEmailForm();
    } else {
      isValid = validatePhoneForm();
    }
    if (isValid) {
      setOtpResendLoading(true);


      let reqBody;
      if (showEmailLogin) {
        reqBody = {
          email: email,
          password: password
        };
      } else {
        reqBody = {
          phone: phone,
          password: password
        }
      }


      axiosInstance
        .post("api/clients/login", reqBody)
        .then((response) => {

          if (response.data.data) {
            setIsLoggedIn(true);
            // console.log("Client user data: ", response.data.data);
            // console.log("Client user token: ", response.data.data.token);
            localStorage.clear();

            localStorage.setItem("client-token", response.data.data.token);
            localStorage.setItem(
              "user",
              JSON.stringify(response.data.data.clientUser)
            );

            setThemes((storedThemes) => storedThemes || "lightMode");

            // ["data_entry_operator", "office_manager","cadre"].includes(
            //   response?.data?.data?.clientUser?.role
            // )
            //   ? navigate("/gms")
            //   : navigate("/dashboard");

            ["data_entry_operator", "office_manager"].includes(response?.data?.data?.clientUser?.role) ? 
                // If data_entry_operator or office_manager → go to GMS
                navigate("/gms")
                : response?.data?.data?.clientUser?.role === "cadre" ? 
                // If cadre → go to Medical Camp
                navigate("/medical-camp")
                : 
                // Otherwise default → Dashboard
                navigate("/dashboard")
      
          } else {
            if (response.data.message === "OTP sent on registered mobile number") {
              toast.success("OTP sent on registered mobile number");
            }
          }

          // console.log("response", response.data);
        })
        .catch((error) => {
          if (error?.response?.data?.message === "This account is suspended.") {
            setOtpError(t("accountSuspended"));
          } else if (error?.response?.data?.message === "clientUser does not exist") {
            setOtpError(t("userNotExist"));
          } else if (error?.response?.data?.message === "You are not authorized to access this application.") {
            setOtpError(t("userNotAuthorized"));
          } else {
            setOtpError(t("invalidEmailPassword"));
          }
        })
        .finally(() => {
          setOtpResendLoading(false);
        });
    }
  };

  // Go back to login screen from OTP screen
  const handleBackToLogin = () => {
    setShowOtpScreen(false);
    setOtp(["", "", "", ""]);
    setOtpError("");
  };

  return (
    <>
      <div className='video-background'>
        <LazyLoad height={200} once>
          <video id='video-bg' autoPlay muted loop>
            <source src={LoginPageVideo} type='video/mp4' />
          </video>
        </LazyLoad>
      </div>
      <ToastContainer />
      <div className='signup-page grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2'>

        <div className='get-in'>
          <div className='logo'>
            <img className='block mx-auto' src={Logo} alt='Logo' />
          </div>
          <div className='text-content'>
            <h2>{t("Welcome")}</h2>
          </div>
          <div className='sign-in-para py-2'>
            <p>{t("Login to your account details below")}</p>
          </div>

          {!showOtpScreen && <form onSubmit={handleLogin}>
            <div className='flex flex-wrap'>
              {showEmailLogin && <div className='py-2 w-full'>
                <div className='mt-7'>
                  <label className='leading-7 text-lg text-gray-600'>
                    {t("Email")}
                  </label>
                  <input
                    value={email}
                    onInput={handleEmailChange}
                    type='email'
                    placeholder={t("Email")}
                    id='email'
                    name='email'
                    required
                    className={`w-full rounded-lg text-base py-2 px-3 mt-2`}
                  />
                  {emailError && (
                    <div className='text-error text-sm mt-1'>{emailError}</div>
                  )}
                </div>
              </div>}

              {!showEmailLogin && <div className='py-2 w-full'>
                <div className='mt-3'>
                  <label className='leading-7 text-lg text-gray-600'>
                    {t("Phone")}
                  </label>
                  <input
                    type='tel'
                    id='phone'
                    name='phone'
                    placeholder={t("Phone")}
                    value={phone}
                    onInput={handlePhoneChange}
                    required
                    className={`w-full rounded-lg text-base py-2 px-3 mt-2 signin-password`}
                  />
                  {phoneError && (
                    <div className='text-error text-sm mt-1'>
                      {phoneError}
                    </div>
                  )}
                </div>
              </div>}

              {showEmailLogin && <div className='py-2 w-full'>
                <div className='mt-3'>
                  <label className='leading-7 text-lg text-gray-600'>
                    {t("Password")}
                  </label>
                  <Input.Password
                    type='password'
                    id='password'
                    name='password'
                    placeholder={t("Password")}
                    value={password}
                    onInput={handlePasswordChange}
                    required
                    className={`w-full rounded-lg text-base py-2 px-3 mt-2 signin-password`}
                  />
                  {passwordError && (
                    <div className='text-error text-sm mt-1'>
                      {passwordError}
                    </div>
                  )}
                </div>
              </div>}





              {loginError && (
                <div className='py-2 w-full'>
                  <div className='text-error text-sm mt-1'>{loginError}</div>
                </div>
              )}

              <div className='w-full flex justify-between my-2 ml-auto '>
                <div onClick={handleLoginFormChangeType} className='forgot-pass-text hover:cursor-pointer'>
                  {showEmailLogin ? t("Login With Phone") : t("Login With Email")}
                </div>

                {/* <Link to='/login/forgot-password' className='forgot-pass-text'>
                  {t("Forgot Password")} ?
                </Link> */}
                <div
                  onClick={() => {
                    setShowEmailLogin(false);
                    // navigate('/login/forgot-password');
                  }}
                  className='forgot-pass-text hover:cursor-pointer'
                >
                  {t("Forgot Password")} ?
              </div>
              </div>

              <div className='py-2 w-full'>
                <div className='my-4'>
                  <button
                    className='flex mx-auto w-full text-white bg-sky-900 border-0 py-3 justify-center focus:outline-none  rounded-lg text-lg'
                    type='submit'
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <svg
                          aria-hidden='true'
                          role='status'
                          className='inline  mr-3 text-white animate-spin'
                          viewBox='0 0 100 101'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                            fill='#E5E7EB'
                          />
                          <path
                            d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                            fill='currentColor'
                          />
                        </svg>
                        <span>{t("loading")}</span>
                      </>
                    ) : (
                      "Login"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>}


          {showOtpScreen && <form onSubmit={handleVerifyOtp}>
            <div className='flex flex-wrap'>
              <div className='py-2 w-full'>
                <div className='mt-3'>
                  <label className='leading-7 text-lg text-gray-600'>
                    {t("Enter 4-digit OTP")}
                  </label>
                  <div className='flex gap-8 mt-2'>
                    {[0, 1, 2, 3].map((index) => (
                      <input
                        key={index}
                        type='text'
                        id={`otp-input-${index}`}
                        maxLength='1'
                        value={otp[index]}
                        onChange={(e) => handleOtpChange(index, e.target.value)}
                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                        className='w-16 h-16 text-center text-xl font-bold rounded-lg border-2 border-gray-300 focus:border-sky-900 focus:outline-none'
                      />
                    ))}
                  </div>
                  {otpError && (
                    <div className='text-error text-sm mt-1'>{otpError}</div>
                  )}
                </div>
              </div>

              <div className='w-full flex justify-between my-2'>
                <button
                  type='button'
                  onClick={handleBackToLogin}
                  className='text-sky-900 hover:underline'
                >
                  <span className='mr-1'>←</span>
                  {t("Back to Login")}
                </button>
                <button
                  type='button'
                  onClick={handleResendOtp}
                  disabled={otpResendLoading}
                  className='text-sky-900 hover:underline'
                >
                  {otpResendLoading ? t("Resending...") : t("Resend OTP")}
                </button>
              </div>

              <div className='py-2 w-full'>
                <div className='my-4'>
                  <button
                    className='flex mx-auto w-full text-white bg-sky-900 border-0 py-3 justify-center focus:outline-none rounded-lg text-lg'
                    type='submit'
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <svg
                          aria-hidden='true'
                          role='status'
                          className='inline mr-3 text-white animate-spin'
                          viewBox='0 0 100 101'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                            fill='#E5E7EB'
                          />
                          <path
                            d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                            fill='currentColor'
                          />
                        </svg>
                        <span>{t("loading")}</span>
                      </>
                    ) : (
                      t("Verify OTP")
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>}



        </div>
      </div>
    </>
  );
};
export default Login;
